<template>
    <div class="singlePDF">
        <div class="add-wrap">
            <div class="defaultImg">
                <p class="add"><i class="el-icon-upload2"></i></p>
                <p>点击此处上传文件</p>
                <p class="tips">只支持上传PDF文件</p>
            </div>
            <input type="file"
                   class="file"
                   @change="addChangePdf"
                   ref="inputImg"
                   accept="application/pdf">
            <div v-if="isUpload">
                <div class="inline-left">
                    <svg class="icon" aria-hidden="true">
                        <use xlink:href="#iconhuabanfuben1"></use>
                    </svg>
                    <p>{{videoName}}</p>
                </div>
                <el-progress :percentage="progress"/>
            </div>
        </div>
<!--        <div class="FullScreen" v-if="isScreen">-->
<!--            <div class="btn" @click="isScreen=false"><p>返回</p></div>-->
<!--            <iframe :src="pdfFile"-->
<!--                    type="application/x-google-chrome-pdf"-->
<!--                    width="100%"-->
<!--                    height="100%"></iframe>-->
<!--        </div>-->
        <div class="pdf" v-if="pdfFile">
<!--            <div class="btn" @click="isScreen=true"><p>全屏</p></div>-->
            <iframe :src="pdfFile"
                    type="application/x-google-chrome-pdf"
                    width="100%"
                    height="100%"></iframe>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    export default {
        name: 'single-pdf',
        props: {
            file: {
                type: String
            },
            fileType: {
                type: String,
                default: '1'
            }
        },
        data() {
            return {
                isScreen: false, // 是否全屏
                isUpload: false, // 正在上传
                videoName: '',
                defaultImg: this.$Public.defaultImg,
                pdfFile: this.file,
                progress: 0
            };
        },
        created() {
        },
        methods: {
            addChangePdf(e) {
                // 上传片pdf
                // console.log(333, e);
                this.upFile(e, res => {
                    this.pdfFile = res;
                    this.$emit('getFile', res);
                    this.$refs.inputImg.value = '';
                    setTimeout(() => {
                        this.isUpload = false;
                    }, 1000);
                });
            },
            upFile(e, fun) {
                // 上传图片
                this.progress = 0;
                let file = e.target.files[0];
                this.videoName = e.target.files[0].name;
                if (!file) {
                    return;
                }
                let time = setInterval(() => {
                    this.progress += 1;
                    // console.log(1111, this.progress);
                    if (this.progress >= 98) {
                        clearTimeout(time);
                    }
                }, 1000);
                this.isUpload = true;
                 console.log(1111, file.name);
                this.httpUploadImg({type: this.fileType, file: file}).then(res => {
                    clearTimeout(time);
                    this.progress = 100;
                    fun(res);
                }, (res) => {
                });
            }
        },
        watch: {
            file(val) {
                this.pdfFile = val;
            }
        }
    };
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    @import '~assets/main.styl';
    .el-icon-upload2 {
        color: blue
    }

    .inline-left {
        margin-top 30px

        .icon {
            width: 16px
            height: 16px
            fill: gary9
            margin-right 10px
        }
    }

    .singlePDF {

        .add-wrap {
            position relative
            width: 300px
            height: 150px
            background grayF6
            border: 1px dashed gray9
            float left
            margin-bottom: 20px;

            .name {
                width: 300px

                p {
                    width: 100%
                }
            }

            .defaultImg {
                width: 300px
                height: 150px

                .add {
                    font-size 30px
                }
                flex-y(center, center);

                p {
                    text-align center
                }
            }
        }

        .edit-wrap {
            position relative

            img {
                width: 100%
                height: 100%
            }
        }

        input {
            width: 100%
            height: 100%
            opacity 0
            position absolute
            top: 0
            left: 0
        }
    }

    .FullScreen {
        width: 100%
        height: 100%
        position: fixed
        top: 0
        left: 0
        z-index:999999
        .btn{
            flex-center()
            position absolute
            right:30px
            top:100px
            width: 40px;
            height: 40px;
            background: white;
            border-radius(50%);
            color: #333;
            cursor pointer
        }
    }

    .pdf {
        width: 700px
        height: 700px
        margin-top 20px
        .btn{
            flex-center()
            position absolute
            right:40px
            top:100px
            width: 40px;
            height: 40px;
            border-radius(50%);
            background: #f6f6f6;
            box-shadow 0px 1px 2px #999;
            color: #333;
            cursor pointer
        }
    }

    p {
        float: left;
    }
</style>
